import { Box, Text } from '~/design_system'
import { Msg } from '~/common/localizationUtils'

export const Welcome = () => {
  return (
    <Box>
      <Text as="h3" fontSize="lg" fontWeight="semibold" color="gray.900" mb={2}>
        <Msg id="assistant.ai.welcome.title" />
      </Text>
      <Text fontSize="sm" color="gray.500" lineHeight="1.6">
        <Msg id="assistant.ai.welcome.description" />
      </Text>
    </Box>
  )
}
